import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet, HelmetProvider } from 'react-helmet-async';

import * as moment from 'moment';
import './Feed.css';
import "./swiper/swiper.css";
import "./calendar/css/calendar.css";
import * as actions from './Actions';
import { fetchInitialData } from "../fetchData";
import Slider from "./swiper/slider";
import SlideItem from "./swiper/slideItem";
import SlideBaby from "./swiper/slideBaby";
import withLocation from "../../WithLocation.js";
import SlideBabyweek from "./swiper/sliderbabyweek";
import SliderConsultwith from "./swiper/sliderConsultwith";
import SliderDietplan from "./swiper/sliderdietplan";
import SliderConsultdoctor from "./swiper/sliderConsultdoctor";

import Slideartical from "./swiper/sliderartical";
import SliderBlogpost from "./swiper/sliderBlog"; 
import SliderparentingTool from "./swiper/parentingTool";

import MealPlaner from "./swiper/mealPlaner";
import TopCategories from "./swiper/topCategories";
import Slidermight from "./swiper/slidermightIniterested.js";

import SliderBreastfeed from "./swiper/sliderBreastfeeding";
import SliderksidsHealth from "./swiper/sliderKidsHealth";
 

import HowFeed from './HowFeed';
import LoggedInRSB from './LoggedInRSB';
import TryingToConcieveRSB from './TryingToConcieveRSB';
import NonLoggedinRsp from './NonLoggedinRsp';

import MLoggedInRSB from './MLoggedInRSB';
import MTryingToConcieveRSB from './MTryingToConcieveRSB';
import MNonLoggedinRsp from './MNonLoggedinRsp';

import Service from '../service/Service';
import Cookies from 'js-cookie';
// import data from "../tools/fetal-movement-tracker/data";
import CommunityFeed from "./CommunityFeed";
import Babythisweek from './community-components/Babythisweek';

import AddChildDetails from './AddChildDetails';
import ChildListOverlay from './ChildListOverlay';
import ChooseWhetherYouAre from './ChooseWhetherYouAre';
import MemoryComment from './MemoryComment';
import UserListOverlay from './UserListOverlay';
import SliderBabyRightsite from "./swiper/sliderBabyRightsite";

import ArticlesImg from "../assets/images/Articles.png";
import ArticlesActiveImg from "../assets/images/Articles_active.png";
import Articles2Img from "../assets/images/Articles2.png";
import Articles2ActiveImg from "../assets/images/Articles2active.png";
import QandAImg from "../assets/images/Q&A-2.png";
import QandAActiveImg from "../assets/images/Q&A-active.png";
import MemoriesImg from "../assets/images/Memories-v2.png";
import MemoriesActiveImg from "../assets/images/Memories-v2_active.png";
import VaccinationTrackerImg from "../assets/images/Vaccination-Tracker-v2.png";
import VaccinationTrackerActiveImg from "../assets/images/Vaccination-Tracker_active.png";
import PersonalizationBG from "../assets/images/Personalization_BG.png";


const service = new Service();
class Feed extends Component {
    constructor(props) {
        console.log("INSIDE FEED COMPONENT :",props)
        // console.log("this.props.isLogin feed==>", this.props.isLogin);
        super(props);
        this.popupRef = React.createRef();
        let isMobile;
        let initialData = [];
        let dfpHorizontalBanner = [];
        let communityHome = [];
        let highlights = [];
        let getlatestfeedpis = [];
        let childProfileData = {};
        let metaTitle = "FirstCry Parenting - Planning, Pregnancy & Parenting Advice and Tips";
        let metaDescription = [
            { "name": "description", "content": "FirstCry Parenting - India's largest community to help you through your journey of Getting Pregnant, Pregnancy & Parenting with Articles, Q&A's, Vaccine & Growth Trackers, Baby Names and more." }
        ];
        let metaKeywords = "parenting community, parenting tips, pregnancy advice";

        let highlightsfeed = [];

        
        let serverSideData = {};
        if (__isBrowser__) {
            if(window.innerWidth < 768) {
              isMobile = true;
            }else{
              isMobile = false;
            }
        }
        // console.log("window.__initialData__ ", window.__initialData__);

        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            // console.log("window.__initialData__['initialData'] ", window.__initialData__['initialData']);

            serverSideData = window.__initialData__['initialData'];
            delete window.__initialData__;

        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                serverSideData = props.staticContext.initialData['initialData'];
            }
        }
        console.log("serverSideData ---qqq ", serverSideData);
  
        if (serverSideData && serverSideData['dfpHorizontalBanner']) {
            initialData = serverSideData;
            dfpHorizontalBanner = initialData['dfpHorizontalBanner'];
            communityHome = initialData['communityHome'];
            highlights = initialData['highlights'];

        }

        // //console.log("banner data",dfpHorizontalBanner);
      
        // page meta data
        // var metadesc = [
        //     { "name": "description", "content": "" }
        // ];
        // var metatitle = "Personalization feed";



 let arrbabySliderDataRight = [
        {
            id:1,
            type:1,
            img:"../../../../images/Personalization_BG.png"
        },
        {
            id:2,
            type:2,
            img:"../../../../images/Personalization_BG.png"
            
        }
        ];

        // slider navigation bar
          let arrNavigationSliderData = [
            {
                id:1,
                img:"https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Articles.png",
                img2:"https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Articles_active.png",
                name:"Home",
                redirectionUrl:'/',
                arialabel:'Home'
            },
            {
                id:2,
                img:"https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Articles2.png",
                img2:"https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Articles2active.png",
                name:"Read",
                redirectionUrl:'https://parenting.firstcry.com/read',
                arialabel:'Go to Read articles'
            },
            {
                id:3,
                img:"https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Q&A-2.png",
                img2:"https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Q&A-active.png",
                name:"Q & A",
                redirectionUrl:'https://parenting.firstcry.com/qna/questions-answers',
                arialabel:'Go to Questions and answers'
            },
            {
                id:4,
                img:"https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Memories-v2.png",
                img2:"https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Memories-v2_active.png",
                name:"Memories",
                redirectionUrl:'https://parenting.firstcry.com/memories/',
                arialabel:'Go to memories'
            },
            {
                id:5,
                img:"https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Vaccination-Tracker-v2.png",
                img2:"https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Vaccination-Tracker_active.png",
                name:"Vaccination",
                redirectionUrl:'https://parenting.firstcry.com/tools/child-vaccination-growth-tracker',
                arialabel:'Go to Vaccination schedule and information'
            }
        
            ];
        // slider navigation bar end 

         // slider baby slider thired
          let arrbabySliderData = [
            {
                id:1,
                type:1,
                img:"https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Personalization_BG.png"
            },
            {
                id:2,
                type:2,
                img:"https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Personalization_BG.png"
                
            }
            ];
        // slider baby slider thired end 


          let babyWeek = communityHome.filter(function(n,i){
            return n.type==='babythisweek';
          })
          babyWeek = (babyWeek)?babyWeek:[]; 

          let BabysizecomparisonSlider = communityHome.filter(function(n,i){
            return n.type==='Babysizecomparison';
          })
          BabysizecomparisonSlider = (BabysizecomparisonSlider)?BabysizecomparisonSlider:[]; 

          let periodDates=communityHome.filter(function(n,i){
            return n.type==="periodovulationcalculator";
          })
          
           periodDates=(periodDates)?periodDates:[];
          //console.log("periodDates",periodDates);


         
         let periodArr = {
"type": "periodovulationcalculator",
"icon": "https://cdn.fcglcdn.com/brainbees/apps/image/period_and_ovulation_calculator.png",
"title": "Period and Ovulation Cycle",
"data": [
  {
"notes": [],
"periodStartDate": "2022-08-16 05:30:00",
"periodEndDate": "2022-08-19 05:30:00",
"mostFertileStartDate": "2022-08-16 07:42:16",
"expectedIcon": "https://cdn.cdnparenting.com/brainbees/community/memoryimages/1650285244712-Expected.png",
"ovulationIcon": "https://cdn.cdnparenting.com/brainbees/community/memoryimages/1650285373230-Ovulation.png",
"fertileStartDate": "2022-08-13 07:42:16",
"fertileIcon": "https://cdn.cdnparenting.com/brainbees/community/memoryimages/1650285346783-Fertile.png",
"cycleEndDate": "2022-09-12 00:00:00",
"expStartDate": "2022-09-13 00:00:00",
"expEndDate": "2022-09-16 00:00:00",
"expCycleEndDate": "2022-10-10 05:30:00",
"expOvulationDay": "2022-09-26 11:00:00",
"expMostFertileStartDate": "2022-09-24 11:00:00",
"expMostFertileEndDate": "2022-09-26 11:00:00",
"expFertileStartDate": "2022-09-21 11:00:00",
"expFertileEndDate": "2022-09-26 11:00:00",
"lastEndDate": "2022-07-22 05:30:00",
"lastStartDate": "2022-07-19 05:30:00",
"lastovulationDay": "2022-08-01 16:30:00",
"lastMostFertileStartDate": "2022-07-30 16:30:00",
"lastFertileStartDate": "2022-07-27 16:30:00",
"lastCycleEndDate": "2022-08-15 11:00:00",
"lastFertileEndDate": "2022-08-01 16:30:00",
"lastMostFertileEndDate": "2022-08-01 16:30:00"
}
]
};

          // communityHome.push(periodArr);

          // //console.log("communityHome --- ", communityHome);
          

        // this.qnaPageNo = 1;
        // this.maxScroll = 0;
        // this.timeout = 0;
        // this.isScrollCall = true;
        this.qnaPageNo = 1;
        this.pageNo = 1;
        this.maxScroll = 0;
        this.timeout = 0;
        this.isScrollCall = true;

        this.state = {        
            popupurl:'',   
            dfpBannerData: dfpHorizontalBanner,
            communityHome: communityHome,
            highlightsfeed: highlights,
            initialData: initialData,
            arryRightsidebaby:arrbabySliderDataRight,
            BabysizecomparisonSlider:BabysizecomparisonSlider,
            periodDates:periodDates,
            babyThisWeek: (babyWeek)?babyWeek[0]:[],
            videoHeight: 360,
            videoWidth: 500,
            arrtoolslider:arrNavigationSliderData,
            arrthirdbaby:arrbabySliderData,
            aDays: '',
            conceptionDate: '',
            firstDate: '',
            loggedin: false,
            isMobile:isMobile,
            IsExpected: false,
            isTryingToConceive:false,
            isDataLoaded : true,
            
 	        childProfileData:{},
            selectedChild:{},
            commentType: '',
            postMemoryId: '',
            postCommentId: '',
            prevComments: [],
	       username:'',
            question_id:'',
            userPhoto:'',
            childInfoReq:'',
            docUrl:'',
            que_type:'child',
            cid:'',
            answer_details:'',
            expectedDob:'',
            user_type:'',
            qnaUserType:'',
            answer_type:'',
            question_type:'',
            question_creater_id:'',
            expecting_dob:'',
            weekbyweekFetalImage: '',
            weekbyweekFetalActive:1,
            babycomparisonImage:'',
            babycomparisonActive:1,
            sizename:'',
            periodArr:periodArr,
            consumeIds : [],
            selected_child_id:'',
            expectedTab:1,
            ageGroup : '',
            window_width: '',
            cFlag: false,
            vid: '',
            image:"https://cdn.fcglcdn.com/brainbees/apps/image/fetal_developmentImage_week1.webp",
            randomValue: '',
            metaTitle: metaTitle,
            metaDescription: metaDescription,
            metaKeywords: metaKeywords,
            fashionTopData:[],
            nonfashionTopData: [],
            dummyProducts : [
                {
                  id: 1,
                  title: "Pampers Pant Style Diapers",
                  bannarImage: "https://cdn.cdnparenting.com/brainbees/community/preact/public/media/06-Expecting.webp",
                  redirectUrl: "/product/diapers",
                },
                {
                  id: 2,
                  title: "MamyPoko Extra absorption",
                  bannarImage: "https://cdn.cdnparenting.com/brainbees/community/preact/public/media/06-Expecting.webp",
                  redirectUrl: "/product/mamypoko",
                },
                {
                  id: 3,
                  title: "Firstcry Combo Pack Kay beauty",
                  bannarImage: "https://cdn.cdnparenting.com/brainbees/community/preact/public/media/06-Expecting.webp",
                  redirectUrl: "/product/firstcry-combo",
                },
                {
                  id: 4,
                  title: "Johnson Baby Oil - 100ml",
                  bannarImage: "https://cdn.cdnparenting.com/brainbees/community/preact/public/media/06-Expecting.webp",
                  redirectUrl: "/product/johnson-oil",
                },
                {
                  id: 5,
                  title: "MeeMee Bottle Set",
                  bannarImage: "https://cdn.cdnparenting.com/brainbees/community/preact/public/media/06-Expecting.webp",
                  redirectUrl: "/product/meemee-bottle",
                },
              ]
        };

       
        // //console.log("initialData::: ",this.state.initialData);
        this.popupRef = React.createRef();
  
    }
   
   
    static initialAction(reqUrl, ftk, authData, uId, childData) {
          let postdataarr;
          console.log("childData ::: ",JSON.stringify(childData));
          console.log("global.userAry['childData'] ===>",global.userAry)
             var header = {
                    'Content-Type': 'application/json',
                    'ftk': ftk,
                    'uid': uId,
                    'access-token': authData['access-token'],
                    'user-agent': global.userAgent,
                    'isdesktop': global.isdesktop
                }
          

            var browser_url = reqUrl.split('/');
            // //console.log("browser_url :: ",browser_url);
            var cohart = '';

            if (browser_url[1] == 'baby-0-2-years') {
                cohart = '0';
            } else if (browser_url[1] == 'toddler-2-4-years') {
                cohart = '1';
            } else if (browser_url[1] == 'kid-4-plus-years') {
                cohart = '2';

            } else if (browser_url[1] == 'expecting') {
                cohart = '5';
            } else if (browser_url[1] == 'trying-to-conceive') {
                cohart = '4';
            }
            else if (browser_url[1] == 'infant-0-6-months') {
                cohart = '0';
            } 
            else if (browser_url[1] == 'big-kid-6-plus-years') {
                cohart = '8';
            } 




            if(childData && childData.UserChildList && childData.UserChildList[0] && ftk!=""){

                let ChildGender = "";
                if(childData.UserChildList[0].Gender && childData.UserChildList[0].Gender.toLocaleLowerCase() == "boy"){
                     ChildGender = 1;
                }else if(childData.UserChildList && childData.UserChildList[0] && childData.UserChildList[0].Gender.toLocaleLowerCase() == "girl"){
                     ChildGender = 0;
                }else{
                     ChildGender = childData.UserChildList[0].Gender?childData.UserChildList[0].Gender:'';
                }
                
              postdataarr = {"childInfo": {
                "childid": (childData.UserChildList)?childData.UserChildList[0].ChildId:'',
                "dob": (childData.UserChildList)?childData.UserChildList[0].DOB:'',
                "childgender": ChildGender,
                "childname": (childData.UserChildList && childData.UserChildList[0].ChildName)?childData.UserChildList[0].ChildName:'',
                "isExpecting": (childData.UserChildList && childData.UserChildList[0].IsExpected)?1:0
              },
              "ageCategory": "",
              "pageNo": "1",
              "daysType": {
                "days": ""
              }, 
              "consumeIds": {}}
            }else{
                // //console.log("In else initial action");
               postdataarr = {"childInfo": {
                  "childid": "",
                  "dob": "",
                  "childgender": "",
                  "childname": "",
                  "isExpecting": "0",
                },
                "ageCategory": (cohart && cohart==5 ?"":cohart),
                "pageNo": "1",
                "daysType": {
                  "days": ""
                },
                "consumeIds": {}}

            }

        if(cohart!=""){
            var url = global.api_url + "prsfeed/getcohortfeed_v1";
        }else{
            var url = global.api_url + "prsfeed/getlatestfeed_v1";
        }
        // //console.log("API URL ::: ",url);

        let body = JSON.stringify(postdataarr);
        return fetchInitialData(url, JSON.stringify(header), body);

    }
    
   
    
    componentWillUnmount() {
        window.removeEventListener("scroll", this.pageData, false);
        document.removeEventListener("click", actions.domClick);
        document.removeEventListener("keydown", this.handleKeyDown);

    }


    onPlayerStateChange = (event) => {
        // //console.log(event);
        // //console.log(event.target.playerInfo.videoData);
        // //console.log(event.target.h.offsetParent);
        let id = event.target.h.offsetParent.getAttribute('data-id');
        if (this.state.isVideoDetailPage && this.vUId != "") {
            id = this.vUId;
        }
        if (event.data == 3) {
            this.playList.push(id);
        } else if (event.data == 1 && this.playList.includes(id)) {
            this.saveVideoAction(id, "view", "1")
        }
    }


    
    closePopupcommon(){
      // document.querySelector(".popUpClose").style.display="none"; 
      document.querySelector(".popUpPersonalised").style.display="none"; 
      document.querySelector(".addAns-overlay.feed").style.display="none";
      document.querySelector(".likes-overlay.feeds").style.display="none";
    }
    
    closePopupComment(){
        document.querySelector(".addReply-overlay").style.display="none";
    }
    
    openPopup(){
        document.querySelector(".popUpClose").style.display="block";
    } 
    openPopupPersonalised(){
        document.querySelector(".popUpPersonalised").style.display="block";
    }


    componentDidMount() {
        document.addEventListener("keydown", this.handleKeyDown);
        // Restore scroll position if available
        const savedScroll = sessionStorage.getItem('scrollPosition');
        //   console.log("savedScroll ====>", savedScroll);
        //   alert("savedScroll ====>"+savedScroll);
         if (savedScroll) {
          setTimeout(() => {
            window.scrollTo(0, parseInt(savedScroll)-1);
            sessionStorage.removeItem('scrollPosition'); // Clear after using
          }, 50); // Give DOM some time to render
        }
        try {
            const childList = global?.userAry?.childData?.UserChildList;
        
            if (Array.isArray(childList) && childList.length > 0 && childList[0]?.ChildId) {
                const child0 = childList[0];
                const childId = child0.ChildId;
                const dob = child0.DOB;
                const gender = child0.Gender;
        
                console.log("global.userArray0 ===>", child0);
        
                if (childList.length > 1 && childList[1]?.ChildId) {
                    console.log("global.userArray1 ===>", childList[1].ChildId);
                }
        
                const ageid = this.youngestChildMapping(dob, gender);
                console.log("ageid ===>", ageid);
        
                this.getTopfashionType(childId, ageid);
                this.getTopnonfashionType(childId, ageid);
            } else {
                console.warn("UserChildList is empty or first child does not have a valid ChildId");
            }
        } catch (error) {
            console.error("An error occurred while processing child data:", error);
        }
        
       
        this.setConsumeData(this.state.communityHome);
       
        // on scroll pagination
        this.setState({ windowWidth: window.outerWidth });
        this.setState({ windowInner: window.innerWidth });
        this.pageData = this.pageData.bind(this);
        // debugger;
        window.addEventListener("scroll", this.pageData, false);

        
        if (navigator.onLine) {
           
                service.showLoader();
                this.getprofileData();
                // //console.log("inside componentDidMount ")
           
        } 
        
        // //console.log("componentDidMount==================>",this.state.initialData);
        if (!(this.props.location.search == "?callAgain=y") && (this.state.initialData) && (this.state.initialData['msg'] == 1 && this.state.initialData.dueFlag)) {
            let JsonData = this.state.initialData;
            if (JsonData.lmpDate) {
                // //console.log("componentDidMount==================>2",this.state.initialData);
                let fDate = new Date(JsonData.lmpDate.replace(/-/g, '/'));
                this.state.firstDate = fDate.getDate() + "-" + this.state.shortMonth[fDate.getMonth()] + "-" + fDate.getFullYear();
            } else {
                this.state.firstDate = 0
            }
            if (JsonData.avgcycledays) {
                this.state.aDays = JsonData.avgcycledays
            } else {
                this.state.aDays = 0
            }
            if (JsonData.conceptionDate) {
                let cDate = new Date(JsonData.conceptionDate.replace(/-/g, '/'));
                this.state.conceptionDate = cDate.getDate() + "-" + this.state.shortMonth[cDate.getMonth()] + "-" + cDate.getFullYear();
            } else {
                this.state.conceptionDate = 0
            }
            let redirectionUrl = "/tools/pregnancy-due-date-calculator/details/" + this.state.firstDate + "/" + this.state.aDays + "/" + this.state.conceptionDate;
            this.props.history.push(redirectionUrl);
        }
        console.log("global.userAry :::===>",global.userAry);
        console.log("global.userAry['IsExpected'] :::===>",global.userAry['IsExpected']);
        console.log("global.ftk :::===>",global.ftk);
        if (global.userAry && global.userAry['IsExpected'] || global.ftk != '') {
            this.setState({ IsExpected: true, loggedin: true });
            // console.log("componentDidMount ====> true ");
        } else {
            this.setState({ IsExpected: false, loggedin: false });
        }
      
       
      
      // week calendar end

        this.childBirthdate();
        this.childDueDate();

            service.loadImages();
            // felal vidio js here
            

             if (navigator.onLine) {
            document.addEventListener("click", actions.domClick);
            this.setState({window_width : window.innerWidth});
            
            if (window.innerWidth > 767) {
                this.setState({ vid: document.querySelector("#videodesk") });
                // document.getElementById('videomob').remove();
            } else {
                this.setState({ vid: document.querySelector("#videomob") });
                // document.getElementById('videodesk').remove();
            }
            this.setState({window_width : window.innerWidth});
        } else {
            service.hideLoader();
            service.showAlert("Please Check Internet Connection!!!");
            return false;
        }

        let randomValue = Math.floor(Math.random() * 10000000);
        this.setState({ randomValue });

        // document.addEventListener("keydown", this.handleKeyDownqna);

    }

    // componentDidUpdate(prevProps) {
    //     if (prevProps.isLogin != this.props.isLogin) {
    //       console.log("HEADER LOGIN STATE CHANGED(isLogin):", this.props.isLogin);
    //     }
    //   }

    playNow() {
        
        if (navigator.onLine) {
            if (!this.state.cFlag) {
                document.querySelector('.pause').style.display = 'none';
                document.querySelector('.play').style.display = 'block';
                document.querySelector("#active-bar").classList.add('changed');
                this.state.cFlag = true;
                document.querySelector("#videodesk").play();
                document.querySelector(".vidTiming").innerHTML = (service.secondsToMS(document.querySelector("#videodesk").duration))
            } else {
                document.querySelector('.play').style.display = 'none';
                document.querySelector('.pause').style.display = 'block';
                document.querySelector("#videodesk").pause();
                this.state.cFlag = false
            }
        } else {
            service.hideLoader();
            service.showAlert("Please Check Internet Connection!!!");
            return false;
        }
    }

    playVideo(e) {
        if (navigator.onLine) {
            let percentage = (document.querySelector("#videodesk").currentTime / document.querySelector("#videodesk").duration) * 100;
            if (document.querySelector("#videodesk") && document.querySelector("#custom-seekbar") && document.querySelector(".custom-timer")) {
                document.querySelector('#custom-seekbar #active-bar').style.width = percentage + '%';
                document.querySelector(".custom-timer").innerText = (service.secondsToMS(document.querySelector("#videodesk").currentTime))
            }
            if (document.querySelector("#videodesk").currentTime === document.querySelector("#videodesk").duration) {
                document.querySelector('.play').style.display = 'none';
                document.querySelector('.pause').style.display = 'block';
                document.querySelector("#active-bar").classList.remove('changed');
                this.state.cFlag = undefined;
            }
        } else {
            service.hideLoader();
            service.showAlert("Please Check Internet Connection!!!");
            return false;
        }
    }
    seekbar(e) {
        if (navigator.onLine) {
            let left = (e.pageX - e.target.getBoundingClientRect().left);
            let totalWidth = document.querySelector("#custom-seekbar").offsetWidth;
            let percentage = (left / totalWidth);
            let vidTime = document.querySelector("#videodesk").duration * percentage;
            if (isFinite(vidTime)) {
                document.querySelector("#videodesk").currentTime = vidTime;
                document.querySelector('.custom-timer').innerText = service.secondsToMS(document.querySelector("#videodesk").currentTime);
            }
        } else {
            service.hideLoader();
            service.showAlert("Please Check Internet Connection!!!");
            return false;
        }
    }


    


    pageData() {
        // this.state.
        // var isDataLoaded = this.state.isDataLoaded;
        var _this = this;
        // //console.log("qnaPageNo -- ", _this.pageNo);
        clearTimeout(_this.timeout);
        _this.timeout = setTimeout(function () {
            if (document.getElementsByClassName('personalization_feed')[0]) {
                var cS = document.getElementsByClassName('personalization_feed')[0].offsetTop;
                var cH = document.getElementsByClassName('personalization_feed')[0].offsetHeight - 2600,
                    wS = window.scrollY - cS;
                    // //console.log("wS - ",window.innerHeight + wS)
                    // //console.log("cH - ",cH);


                    // if(window.scrollY >= document.getElementsByClassName('personalization_feed')[0].offsetHeight - 600){
                    //     alert(123);
                    // }

                    
                // if (((window.innerHeight + window.scrollY) >= document.body.offsetHeight) && wS > cH) {
                    console.log("window.scrollY - ",window.scrollY);
                    console.log("document.getElementsByClassName('personalization_feed')[0].offsetHeight - 600 - ",document.getElementsByClassName('personalization_feed')[0].offsetHeight - 600);
                    if(window.scrollY >= document.getElementsByClassName('personalization_feed')[0].offsetHeight - 600){
                    console.log("##################INSIDE FIRST IF OF SCROLL##################");
                    if (wS > _this.maxScroll && _this.isScrollCall ) {
                        console.log("##################INSIDE SECOND IF OF SCROLL##################");
                        
                        // this.setState({isDataLoaded:false});
                        _this.maxScroll = wS;
                        ++_this.pageNo;
                        if(_this.pageNo<=4){
                            console.log("pagination call -- ", _this.pageNo);
                            
                            service.showScrollLoader();
                            _this.getLatestFeed(_this.pageNo);

                        }else{
                            _this.isScrollCall = false;
                            // //console.log("pagination limit exceeded.")
                        }
                        
                    } else {
                        return false;
                    }
                }
            }
        }, 100)
    }

    // getLatestFeed(pageno) {
        
    //     //new
    //     var browser_url = window.location.href.split('/');
    //     // //console.log("browser_url :: ",browser_url);
    //     var cohart = '';
    //     let ageCategory;
    //     if(this.state.selectedChild.isTryingToConceive > 0){
    //         ageCategory = "4";
    //    }

    //     if (browser_url[3] == 'baby-0-2-years') {
    //         cohart = '7';
    //     } else if (browser_url[3] == 'toddler-2-4-years') {
    //         cohart = '1';
    //     } else if (browser_url[3] == 'kid-4-plus-years') {
    //         cohart = '2';

    //     } else if (browser_url[3] == 'expecting') {
    //         cohart = '5';
    //     } else if (browser_url[3] == 'trying-to-conceive') {
    //         cohart = '4';
    //     }
    //     else if (browser_url[3] == 'infant-0-6-months') {
    //         cohart = '0';
    //     } 
    //     else if (browser_url[3] == 'big-kid-6-plus-years') {
    //         cohart = '8';
    //     } 
    //     var postdataarr;
    //       console.log("pagination ::: ",JSON.stringify(global.userAry));
    //       console.log("global.ftk ::: ",global.ftk);
    //       console.log("ftk ::: ",ftk);
    //       console.log("global.userAry :",global.userAry)
    //       console.log("global.userAry['childData']['UserChildList'] :",global.userAry['childData']['UserChildList'])
    //       console.log("global.userAry['childData']['UserChildList'][0] :",global.userAry['childData']['UserChildList'][0])

    //         if(global.userAry && global.userAry['childData']['UserChildList'] && global.userAry['childData']['UserChildList'][0] && ftk!=""){
    //             console.log("HI, i reach here inside 1 if")


    //             if(this.state.selectedChild && this.state.selectedChild.childId){

    //                     let ChildGender = "";
    //                     if(this.state.selectedChild.gender.toLocaleLowerCase() == "boy"){
    //                          ChildGender = 1;
    //                     }else if(this.state.selectedChild.gender.toLocaleLowerCase() == "girl"){
    //                          ChildGender = 0;
    //                     }else{
    //                         ChildGender = this.state.selectedChild.gender?this.state.selectedChild.gender:'';
    //                     }

    //                   postdataarr = {"childInfo": {
    //                     "childid": (this.state.selectedChild)?this.state.selectedChild.childId:'',
    //                     "dob": (this.state.selectedChild)?this.state.selectedChild.dob:'',
    //                     "childgender": ChildGender,
    //                     "childname": (this.state.selectedChild && this.state.selectedChild.childName)?this.state.selectedChild.childName:'',
    //                     "isExpecting": this.state.selectedChild.isExpecting
    //                   },
    //                   "ageCategory": "",
    //                   "pageNo": pageno,
    //                   "daysType": {
    //                     "days": ""
    //                   },
    //                   "consumeIds": this.state.consumeIds };
    //             }else{
    //                     let ChildGender = "";
    //                     if(global.userAry['childData']['UserChildList'][0].gender && global.userAry['childData']['UserChildList'][0].gender.toLocaleLowerCase() == "boy"){
    //                          ChildGender = 1;
    //                     }else if(global.userAry['childData']['UserChildList'][0].gender && global.userAry['childData']['UserChildList'][0].gender.toLocaleLowerCase() == "girl"){
    //                          ChildGender = 0;
    //                     }else{
    //                         ChildGender = global.userAry['childData']['UserChildList'][0].gender?global.userAry['childData']['UserChildList'][0].gender:'';
    //                     }

    //                   postdataarr = {"childInfo": {
    //                     "childid": (global.userAry['childData']['UserChildList'])?global.userAry['childData']['UserChildList'][0].childId:'',
    //                     "dob": (global.userAry['childData']['UserChildList'])?global.userAry['childData']['UserChildList'][0].dob:'',
    //                     "childgender": ChildGender,
    //                     "childname": (global.userAry['childData']['UserChildList'] && global.userAry['childData']['UserChildList'][0].childName)?global.userAry['childData']['UserChildList'][0].childName:'',
    //                     "isExpecting": (global.userAry['childData']['UserChildList'] && global.userAry['childData']['UserChildList'][0].isExpecting)?global.userAry['childData']['UserChildList'][0].isExpecting:0
    //                   },
    //                   "ageCategory": ageCategory,
    //                   "pageNo": pageno,
    //                   "daysType": {
    //                     "days": ""
    //                   },
    //                   "consumeIds": this.state.consumeIds};
    //             }

                
    //         }else{
    //             console.log("HI, i reach here inside 1 else")

    //            postdataarr = {"childInfo": {
    //               "childid": "",
    //               "dob": "",
    //               "childgender": "",
    //               "childname": "",
    //               "isExpecting": 0,
    //             },
    //             "ageCategory": cohart,
    //             "pageNo": pageno,
    //             "daysType": {
    //               "days": ""
    //             },
    //             "consumeIds": this.state.consumeIds};
    //         }

    //     console.log("HI, i reach here 1")

    //     // if((this.state.selectedChild.isTryingToConceive> 0 && this.state.selectedChild.childId=="")|| cohart=='4' ){
    //     //      var url = global.api_ci_url + "PersonalizationFeed/getUpdatedFeedsCohart";
    //     // }else{
    //     //      var url = global.api_ci_url + "PersonalizationFeed/getUpdatedFeeds";
    //     // }
    //     if(global.ftk==""){
    //         console.log("HI, i reach here inside if")

    //         if(cohart=='5'){
    //             var url = global.api_ci_url + "PersonalizationFeed/getUpdatedFeeds";
    //         }else{
    //             var url = global.api_ci_url + "PersonalizationFeed/getUpdatedFeedsCohart";
    //         }
    //     }else{
    //         console.log("HI, i reach here inside else")

    //         if((this.state.selectedChild.isTryingToConceive> 0 && this.state.selectedChild.childId=="")|| cohart=='4' ){
    //                  var url = global.api_ci_url + "PersonalizationFeed/getUpdatedFeedsCohart";
    //             }else{
    //                  var url = global.api_ci_url + "PersonalizationFeed/getUpdatedFeeds";
    //             }
    //     }
    //     console.log("Above service")
    //     console.log(" above postdataarr---",postdataarr);
    //     console.log("url---",url)
    //     // var url = global.api_ci_url + "personalizationFeed/getUpdatedFeeds";
    //     service.postServiceCall(url, postdataarr).then((json) => {
    //         console.log("postdataarr---",postdataarr);
    //         console.log("json------",json);
    //         if (json.msg == "1") {
    //             this.setState({ communityHome: this.state.communityHome.concat(json.communityHome) });
    //             this.setConsumeData(this.state.communityHome);
    //             // //console.log("in response",this.state.communityHome)
    //         }
    //         service.hideScrollLoader();
    //         // this.setState({isDataLoaded:true});
    //     }).catch((error) => {
    //         console.error(error);
    //         service.hideLoader();
    //         // this.setState({isDataLoaded:true});
    //     });
    // }

    getLatestFeed(pageno) {

        console.log("========== getLatestFeed START ==========");
        console.log("Page No:", pageno);
    
        var browser_url = window.location.href.split('/');
        console.log("Browser URL Parts:", browser_url);
    
        var cohart = '';
        let ageCategory = "";
    
        console.log("Selected Child State:", this.state.selectedChild);
    
        if (this.state.selectedChild?.isTryingToConceive > 0) {
            ageCategory = "4";
            console.log("Age Category set from TryingToConceive:", ageCategory);
        }
    
        // Cohort detection
        const pathSegment = browser_url[3];
        console.log("URL Segment for Cohort:", pathSegment);
    
        if (pathSegment == 'baby-0-2-years') {
            cohart = '7';
        } else if (pathSegment == 'toddler-2-4-years') {
            cohart = '1';
        } else if (pathSegment == 'kid-4-plus-years') {
            cohart = '2';
        } else if (pathSegment == 'expecting') {
            cohart = '5';
        } else if (pathSegment == 'trying-to-conceive') {
            cohart = '4';
        } else if (pathSegment == 'infant-0-6-months') {
            cohart = '0';
        } else if (pathSegment == 'big-kid-6-plus-years') {
            cohart = '8';
        }
    
        console.log("Final Cohart Value:", cohart);
    
        console.log("Global userAry:", global.userAry);
        console.log("Global ftk:", global.ftk);
    
        var postdataarr;
    
        if (
            global.userAry &&
            global.userAry?.childData?.UserChildList?.[0] &&
            global.ftk != ""
        ) {
    
            console.log("✅ Entered MAIN IF block (User + Child + ftk exists)");
    
            if (this.state.selectedChild?.childId) {
    
                console.log("➡ Using selectedChild data");
    
                let ChildGender = "";
                const gender = this.state.selectedChild.gender?.toLowerCase();
    
                if (gender == "boy") {
                    ChildGender = 1;
                } else if (gender == "girl") {
                    ChildGender = 0;
                } else {
                    ChildGender = gender || "";
                }
    
                console.log("Selected Child Gender Parsed:", ChildGender);
    
                postdataarr = {
                    childInfo: {
                        childid: this.state.selectedChild.childId || '',
                        dob: this.state.selectedChild.dob || '',
                        childgender: ChildGender,
                        childname: this.state.selectedChild.childName || '',
                        isExpecting: this.state.selectedChild.isExpecting
                    },
                    ageCategory: "",
                    pageNo: pageno,
                    daysType: { days: "" },
                    consumeIds: this.state.consumeIds
                };
    
            } else {
    
                console.log("➡ Using FIRST CHILD from global.userAry");
    
                const firstChild = global.userAry.childData.UserChildList[0];
    
                let ChildGender = "";
                const gender = firstChild.gender?.toLowerCase();
    
                if (gender == "boy") {
                    ChildGender = 1;
                } else if (gender == "girl") {
                    ChildGender = 0;
                } else {
                    ChildGender = gender || "";
                }
    
                console.log("Global Child Gender Parsed:", ChildGender);
    
                postdataarr = {
                    childInfo: {
                        childid: firstChild.childId || '',
                        dob: firstChild.dob || '',
                        childgender: ChildGender,
                        childname: firstChild.childName || '',
                        isExpecting: firstChild.isExpecting || 0
                    },
                    ageCategory: ageCategory,
                    pageNo: pageno,
                    daysType: { days: "" },
                    consumeIds: this.state.consumeIds
                };
            }
    
        } else {
    
            console.log("❌ Entered ELSE block (No user / No child / No ftk)");
    
            postdataarr = {
                childInfo: {
                    childid: "",
                    dob: "",
                    childgender: "",
                    childname: "",
                    isExpecting: 0,
                },
                ageCategory: cohart,
                pageNo: pageno,
                daysType: { days: "" },
                consumeIds: this.state.consumeIds
            };
        }
    
        console.log("Final Post Data:", JSON.stringify(postdataarr, null, 2));
    
        // URL selection
        let url;
    
        if (global.ftk == "") {
    
            console.log("FTK is EMPTY");
    
            if (cohart == '5') {
                url = global.api_ci_url + "PersonalizationFeed/getUpdatedFeeds";
            } else {
                url = global.api_ci_url + "PersonalizationFeed/getUpdatedFeedsCohart";
            }
    
        } else {
    
            console.log("FTK is PRESENT");
    
            if (
                (this.state.selectedChild?.isTryingToConceive > 0 &&
                    this.state.selectedChild?.childId == "") ||
                cohart == '4'
            ) {
                console.log("➡ Calling Cohart API");
                url = global.api_ci_url + "PersonalizationFeed/getUpdatedFeedsCohart";
            } else {
                console.log("➡ Calling Normal Feed API");
                url = global.api_ci_url + "PersonalizationFeed/getUpdatedFeeds";
            }
        }
    
        console.log("Final API URL:", url);
        console.log("========== API CALL START ==========");
    
        service.postServiceCall(url, postdataarr)
            .then((json) => {
    
                console.log("API RESPONSE:", json);
    
                if (json.msg == "1") {
                    console.log("✅ Feed Success - Appending Data");
                    this.setState({
                        communityHome: this.state.communityHome.concat(json.communityHome)
                    });
                    this.setConsumeData(this.state.communityHome);
                } else {
                    console.log("⚠ API returned msg != 1");
                }
    
                service.hideScrollLoader();
                console.log("========== getLatestFeed END ==========");
            })
            .catch((error) => {
                console.error("❌ API ERROR:", error);
                service.hideLoader();
            });
    }
  


    getLatestFeedByChild(childData) { 
        var _this = this;
        this.qnaPageNo = 1;
        this.pageNo = 1;
        this.maxScroll = 0;
        this.timeout = 0;
        this.isScrollCall = true;
        this.setState({ consumeIds: [] });
        service.showLoader();        
        this.setState({selectedChild:childData});
        /* set age group for GA*/

        let ageGrp = '';
        let ageCat;
        let ageMonth;
        if(childData.isExpecting==1)
        {
            ageGrp="Exp";
        }else if(childData.isTryingToConceive==1){
            ageGrp="try";
        }else{
            ageCat = childData.age?.year;
            ageMonth = childData.age?.month;
        }

         if (ageCat <= 1) {
             ageGrp = '0-1';
         }
         if ((ageCat <=2 && ageCat >=1) && (ageCat ==2 && !ageMonth)) {
             ageGrp = '1-2';
         } else if (ageCat <= 4 && ageCat >= 2) {
             ageGrp = "2-4";
         }
         else if (4 < ageCat) {
             ageGrp = "4+";
         }
         Cookies.set("ageGroup", JSON.stringify(ageGrp), { domain: '.firstcry.com' });
        // this.setState({ageGroup: ageGrp});


        /* end age group*/

        //new

        var postdataarr;
        //   //console.log("childData ::: ",JSON.stringify(childData));
          let ageCategory = "";
         // debugger;
            if(childData && ftk!=""){
               
                if(childData.isTryingToConceive > 0){
                     ageCategory = "4";
                }
                let ChildGender = "";
                if(childData.gender && childData.gender.toLocaleLowerCase() == "boy"){
                     ChildGender = 1;
                }else if(childData.gender && childData.gender.toLocaleLowerCase() == "girl"){
                     ChildGender = 0;
                }else{
                     ChildGender = childData.gender?childData.gender:'';
                }

              postdataarr = {"childInfo": {
                "childid": (childData)?childData.childId:'',
                "dob": (childData)?childData.dob:'',
                "childgender": ChildGender,
                "childname": (childData && childData.childName)?childData.childName:'',
                "isExpecting": childData.isExpecting
              },
              "ageCategory": ageCategory,
              "pageNo": 1,
              "daysType": {
                "days": ""
              },
              "consumeIds": this.state.consumeIds};
            }else{
               postdataarr = {"childInfo": {
                  "childid": "",
                  "dob": "",
                  "childgender": "",
                  "childname": "",
                  "isExpecting": 0,
                },
                "ageCategory": "",
                "pageNo": 1,
                "daysType": {
                  "days": ""
                },
                "consumeIds": this.state.consumeIds};
            }

            let dob = childData.dob ? childData.dob :'';
            let childId = childData.childId ? childData.childId : '';
            let gender = childData.gender ? childData.gender :'';
    
            const ageid = this.youngestChildMapping(dob, gender);
            console.log("ageid inside getLatestFeed ===>", ageid);
    
            this.getTopfashionType(childId, ageid);
            this.getTopnonfashionType(childId, ageid);

        if(childData.isTryingToConceive > 0 && childData.childId==""){
            var url = global.api_ci_url + "personalizationFeed/getUpdatedFeedsCohart";
        }else{
            var url = global.api_ci_url + "personalizationFeed/getUpdatedFeeds";
        }
        // //console.log("API URL ::: ",url);
        // //console.log("BODY",postdataarr);
        service.postServiceCall(url, postdataarr).then((json) => {
            if (json.msg == "1") {
                this.setState({ communityHome: json.communityHome });
                this.setState({ highlightsfeed: json.highlights });
                this.setState({dfpBannerData : json.dfpHorizontalBanner})
                this.setConsumeData(this.state.communityHome);
              
               
                let periodDates=json.communityHome && json.communityHome.filter(function(n,i){
                    return n.type==="periodovulationcalculator";
                  })
                  periodDates=(periodDates)?periodDates:[]
                //   //console.log("periodDates",periodDates)
                  


                  let babyWeek = json.communityHome.filter(function(n,i){
                    return n.type==='babythisweek';
                  })
                  // babyWeek = (babyWeek)?babyWeek:[]; 
                //   //console.log("on child changed :::::",babyWeek);

                this.setState({
                    periodDates:periodDates,
                    babyThisWeek: (babyWeek && babyWeek[0])?babyWeek[0]:[]
                })
                
        
                // //console.log("in response json",json)
            }
            service.hideLoader();
            document.querySelector(".select_child_popup").style.display="none";
            // this.setState({isDataLoaded:true});
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
            // this.setState({isDataLoaded:true});
        });

 
        
    }
 

    getPeriodDate(){
        var begin = moment().isoWeekday(1).startOf('isoweek');
                // //console.log("begin ",begin);
                var currentDate = moment().format("D");
                // //console.log("currentDate:: ",currentDate);
                var str = "";
                var period=actions.formatPeriodDate(this.state.periodDates && this.state.periodDates.data && this.state.periodDates.data[0] && this.state.periodDates.data[0].periodStartDate);
                var periodEndDate = period+4;
                for (var i=0; i<7; i++) {
                    var date = begin.format('D');
                    var last_three_class="";
                    var last_class="";
                    if(i<3){
                    last_three_class = "range_selected";
                        if(i==3){
                            last_class = "last";
                        }else{
                            last_class = "";
                        }
                    }
                    
                    if( date >= period &&  date < periodEndDate){
                    // last_three_class = "range_selected";
                            last_class = "";
                    var html = "<div id="+last_three_class+" class="+last_class+"> <span id='selected'>"
                    }
                    else {
                        // //console.log("In else")
                        if(date == currentDate){
                    var html = "<div id="+last_three_class+"  class="+last_class+"> <span id='selected'>";
                        }
                        else{
                                  var html = "<div id="+last_three_class+"> <span > ";
                                }
                    }
                    
                    str+=html+date+"</span> </div>";
                    begin.add('d', 1);
                    
                    }
               document.querySelector('.calendar-week').innerHTML = str;
               const lastA = Array.from(
                document.querySelectorAll('#range_selected')
              ).pop();
              
              lastA.classList.add("last");
            
              ////console.log(last); // 👉️ div.box
              ////console.log(last.textContent);
    }

  getprofileData(){
        // debugger;
        console.log("global.userAry in getprofileData:", global.userAry);

         var url = global.api_ci_url + "PersonalizationFeed/getChildProfileData";
        // var url='http://35.154.23.30:8081/prsfeed/getchildprofile';

        let postdata = {
         "IsTryingToConceive": 0
        };
        
        // //console.log(url);
        
        service.postServiceCall(url, postdata).then((json) => {
            console.log("getChildProfileData raw response ==>", json);
            console.log("getChildProfileData response.msg ==>", json?.['response']?.['msg']);
            console.log("getChildProfileData response.childArr ==>", json?.['response']?.['childArr']);
            if (json['response']['msg'] == "1") {
                var res = json['response'];
               if(json['response'].userArr && json['response'].userArr.isTryingToConceive > 0){
                     
                        res.childArr.push({
                            "childName": "",
                            "childId": "",
                            "childPhoto": "",
                            "userPic": "https://cdn.cdnparenting.com/brainbees/community/memoryimages/1659418444911-1659418439_1659418439.png",
                            "isTryingToConceive": 1,
                            "dob": "",
                            "isExpecting": 0,
                            "currentWeek": 0,
                            "age": {
                                "year": 0,
                                "month": 0,
                                "days": 0
                            },
                            "childAge": 0,
                            "gender": "",
                            "weight": "",
                            "height": ""
                        });
                        //json["response"].childArr.push(TryingToConcieve);
                }    

                this.setState({ 
                    childProfileData : res
                    });
                   console.log("res child",res);
                    let cdata=res.childArr;
                    let childDataToPass = (cdata && cdata[0])?cdata[0]:[];
                    // this.getLatestFeedByChild(childDataToPass);
                       // let tempChildArr = json['response'].childArr.concat(TryingToConcieve);
                   // //console.log("tempChildArr",tempChildArr)
                    // this.setState({ 
                    //     childProfileData : tempChildArr
                    //     });
                   // this.state.childProfileData.childArr=json['response'].childArr.concat(TryingToConcieve);
            //    //console.log("childProfileData ---", this.state.childProfileData.childArr)
            //    //console.log("json['response'] child concat",json['response'])
               console.log("getprofileData setting selectedChild ==>", childDataToPass);
               this.setState({selectedChild:(childDataToPass)?childDataToPass:[]});
            //    //console.log("selectedChild ::: prifile :::",this.state.selectedChild)
               /* set age group for GA*/

                let ageGrp = '';
                let ageCat;
                let ageMonth;
                if(childDataToPass.isExpecting==1)
                {
                    ageGrp="Exp";
                }else if(childDataToPass.isTryingToConceive==1){
                    ageGrp="try";
                }else{
                    ageCat = childDataToPass.age?.year;
                    ageMonth = childDataToPass.age?.month;
                }

                 if (ageCat <= 1) {
                     ageGrp = '0-1';
                 }
                 if ((ageCat <=2 && ageCat >=1) && (ageCat ==2 && !ageMonth)) {
                     ageGrp = '1-2';
                 } else if (ageCat <= 4 && ageCat >= 2) {
                     ageGrp = "2-4";
                 }
                 else if (4 < ageCat) {
                     ageGrp = "4+";
                 }
                 Cookies.set("ageGroup", JSON.stringify(ageGrp), { domain: '.firstcry.com' });
                // this.setState({ageGroup: ageGrp});


                /* end age group*/
               
                // //console.log("Child Data",this.state.childProfileData);
                // localStorage.setItem('childProfileData', JSON.stringify(json['result'][0]));
            // }else{
            //     this.setState({ 
            //     childProfileData : json['response']
            //     });
            //     }
            // //console.log("childProfileData ---", this.state.childProfileData)

        
        }else{
                let catdata =[
                    {
                        "childName": global.userAry['userName'],
                        "childId": global.userAry['mycid'],
                        "childPhoto": "",
                        "userPic": global.userAry['userPhoto'],
                        "isTryingToConceive": global.userAry['IsTryingToConceive'],
                        "dob": global.userAry['expectedDob'],
                        "isExpecting": global.userAry['IsExpecting'],
                        "currentWeek": "",
                        "age": {
                            "year": "",
                            "month": "",
                            "days": ""
                        },
                        "childAge": "",
                        "gender": "",
                        "weight": "",
                        "height": ""
                    }
                ];
                this.setState({ 
                    childProfileData : catdata
                   
                });
                // //console.log("childProfileData ---", this.state.childProfileData)
                // //console.log("global===========",global)
            }
           
            service.hideLoader();
        }).catch((error) => {
            console.error("getChildProfileData request failed, selectedChild NOT updated:", error);
            service.hideLoader();
        });
    }

    parseTopFashionData = (typesStr) => {
        return typesStr.split("#").map((item, idx) => {
          const parts = item.split("-");
          const productid = parts[5] || "";
          const subcatname =
          (parts[2]?.replace(/'/g, "").charAt(0).toUpperCase() +
            parts[2]?.replace(/'/g, "").slice(1)) || "";
                  const viewcount = parts[7] || "";
      
          let fcspecchar = "";
          const typeno = parseInt(parts[3] || "0", 10);
          const typeid = parts[4] || "";
          for (let i = 1; i <= typeno; i++) {
            fcspecchar += "@";
          }
      
        //   const url = `https://www.firstcry.com/${this.ReplaceSymbols(subcatname)}/${parts[0]}/${parts[1]}?scat=${parts[1]}${fcspecchar}~${typeid}&sort=bestseller${this.ref2Creation(subcatname, 'fctr', 'pp')}`;
        const url = `https://www.firstcry.com/${this.ReplaceSymbols(subcatname)}/${parts[0]}/${parts[1]}?scat=${parts[1]}${fcspecchar}~${typeid}&sort=bestseller&ref2=phptoproductlisting`;

          
          console.log("Parsed Data:", {
            id: productid,
            title: subcatname,
            imageUrl: `https://cdn.fcglcdn.com/brainbees/images/products/240x290/${productid}a.webp`,
            redirectUrl: url,
            viewcount
          });
        
        return {
            id: productid,
            title: subcatname,
            imageUrl: `https://cdn.fcglcdn.com/brainbees/images/products/240x290/${productid}a.webp`, // Assuming images are named after productid
            redirectUrl: url,
            viewcount
          };
        });
      };

    ReplaceSymbols = (inputString) => {
        if (!inputString || typeof inputString !== 'string' || inputString.trim() === '') return inputString;
      
        return inputString
          .trim()
          .toLowerCase()
          .replace(/é/g, 'e')
          .replace(/,/g, '')
          .replace(/’/g, '')
          .replace(/`/g, '')
          .replace(/\|/g, '')
          .replace(/ +/g, '-')
          .replace(/\?/g, '-')
          .replace(/:/g, '-')
          .replace(/\./g, '')
          .replace(/&/g, 'and')
          .replace(/\+/g, '')
          .replace(/\//g, '-')
          .replace(/!/g, '')
          .replace(/'/g, '')
          .replace(/ +- +/g, '-')
          .replace(/- + +/g, '-')
          .replace(/ + +-/g, '-')
          .replace(/%20/g, '-')
          .replace(/%/g, '-')
          .replace(/---/g, '-')
          .replace(/--/g, '-')
          .replace(/\)/g, '')
          .replace(/\(/g, '')
          .replace(/#/g, '')
          .replace(/</g, '')
          .replace(/>/g, '')
          .replace(/"/g, '')
          .replace(/~/g, '')
          .replace(/\*/g, '')
          .replace(/;/g, '-')
          .replace(/@/g, '')
          .replace(/=/g, '')
          .replace(/\$/g, '')
          .replace(/\\/g, '')
          .replace(/\[/g, '')
          .replace(/\]/g, '')
          .replace(/_/g, '-')
          .replace(/°/g, '')
          .replace(/©/g, '')
          .replace(/-e2-80-99/g, '')
          .replace(/-c3-a9/g, 'e')
          .replace(/\s+/g, '-')
          .replace(/®/g, '');
      };
      
    ref2Creation(subname, unit_name, navigatin_src) {
        try {
          if (subname?.trim() && unit_name?.trim() && navigatin_src?.trim()) {
            let tokenizeNam = subname
              .toLowerCase()
              .replace(/, /g, '_')
              .replace(' / ', '_')
              .replace(/and /g, '')
              .replace(/of /g, '')
              .replace(/ /g, '-')
              .split('-');
      
            let type_name = tokenizeNam.length > 1
              ? tokenizeNam[0] + '_' + tokenizeNam[1]
              : tokenizeNam[0];
      
            return '&ref2=fccor_' + unit_name + '_' + type_name + '_' + navigatin_src;
          } else {
            return '';
          }
        } catch (e) {
          return '';
        }
    }
      
    getTopfashionType = (childId, ageId) => {
        const { selectedChild } = this.state;
        const ftk = global.ftk || ""; 
        const childid = childId
        const ageid = ageId;

        console.log("getTopfashionType called with :", childid , ageid);

        const url = "https://www.firstcry.com/dfpapi/recommendation/topfashiontype";
        const postdata = {
          ftk,
          childid,
          ageid
        };

        // const parsedData = this.parseTopFashionData("6-164-'rompers'-1-388-16309005-87-8836-4122#6-166-'t shirts and bottoms'-1-8925-14199066-85.02-14157-4011#6-169-'towel and wrappers'-1-429-11733779-82.04-8953-4860#6-168-'one piece dresses / frocks'-3-8829-16235060-88-12991-3736#6-164-'onesies'-1-387-17748452-86-14895-4507#6-26-'t shirts'-1-8895-16708577-87.52-11476-4740#6-164-'bodysuits'-1-8889-14454509-72-14571-4351#6-168-'frocks with bloomer / short'-3-6643-16235169-77.79-8680-4945#6-170-'booties'-1-2454-16405127-72-13563-4726#6-166-'tops and bottoms'-1-8926-14187499-83-14179-4956#6-221-'shorts'-1-1635-15742810-89.5-9828-3666#6-22-'caps'-1-422-16404818-75.16-9678-4327#6-165-'sleep suits'-1-1555-18214868-72-10865-3769#6-169-'hand and face towels'-1-6370-9399149-78.87-12203-4720#6-22-'mittens and booties'-1-1500-16173715-75.04-9772-4352#6-243-'party suits'-3-3652-18042603-88-10321-3766#6-22-'summer caps'-1-6328-17545876-72-12527-4387#6-219-'sweater sets'-1-1173-17513894-75-14780-4023");
        // this.setState({ fashionTopData: parsedData }, () => {
        //     console.log("Fashion Updated state:", this.state.fashionTopData);
        //   });
                
        service.postServiceCall1(url, postdata).then((res) => {
          if (res?.types) {
            const parsedData = this.parseTopFashionData(res.types);
            this.setState({ fashionTopData: parsedData }, () => {
                console.log("Fashion Updated state:", this.state.fashionTopData);
              });          }
        }).catch((error) => {
          console.error("Top Fashion API Error", error);
        });
    }
    getTopnonfashionType = (childId,ageId) => {
        const { selectedChild } = this.state;
        const ftk = global.ftk || ""; 
        const childid = childId;
        const ageid = ageId; 
        console.log("getTopnonfashionType called with :", childid , ageid);


        const url = "https://www.firstcry.com/dfpapi/recommendation/topnonfashiontype";
        const postdata = {
          ftk,
          childid,
          ageid
        };

        // const parsedData = this.parseTopFashionData("6-164-'rompers'-1-388-16309005-87-8836-4122#6-166-'t shirts and bottoms'-1-8925-14199066-85.02-14157-4011#6-169-'towel and wrappers'-1-429-11733779-82.04-8953-4860#6-168-'one piece dresses / frocks'-3-8829-16235060-88-12991-3736#6-164-'onesies'-1-387-17748452-86-14895-4507#6-26-'t shirts'-1-8895-16708577-87.52-11476-4740#6-164-'bodysuits'-1-8889-14454509-72-14571-4351#6-168-'frocks with bloomer / short'-3-6643-16235169-77.79-8680-4945#6-170-'booties'-1-2454-16405127-72-13563-4726#6-166-'tops and bottoms'-1-8926-14187499-83-14179-4956#6-221-'shorts'-1-1635-15742810-89.5-9828-3666#6-22-'caps'-1-422-16404818-75.16-9678-4327#6-165-'sleep suits'-1-1555-18214868-72-10865-3769#6-169-'hand and face towels'-1-6370-9399149-78.87-12203-4720#6-22-'mittens and booties'-1-1500-16173715-75.04-9772-4352#6-243-'party suits'-3-3652-18042603-88-10321-3766#6-22-'summer caps'-1-6328-17545876-72-12527-4387#6-219-'sweater sets'-1-1173-17513894-75-14780-4023");
        // this.setState({ nonfashionTopData: parsedData }, () => {
        //     console.log("Non fashion Updated state :", this.state.nonfashionTopData);
        //   });
            service.postServiceCall1(url, postdata).then((res) => {
          if (res?.types) {
            const parsedData = this.parseTopFashionData(res.types);
            this.setState({ nonfashionTopData: parsedData }, () => {
                console.log("Non fashion Updated state :", this.state.nonfashionTopData);
              });          }
        }).catch((error) => {
          console.error("Top Non Fashion API Error", error);
        });
    }
    parseSafeDate(d) {
        if (!d) return null;
        const parts = d.trim().split("-");
        
        // Handle dd-MMM-yyyy
        if (parts.length === 3 && isNaN(parts[1])) {
          const [day, mon, year] = parts;
          const monthNames = {
            jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5,
            jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11
          };
          const month = monthNames[mon.toLowerCase()];
          if (month === undefined) return null;
          return new Date(Number(year), month, Number(day));
        }
      
        // Handle yyyy-mm-dd
        if (parts.length === 3 && !isNaN(parts[1])) {
          const [year, month, day] = parts.map(p => Number(p));
          return new Date(year, month - 1, day);
        }
      
        return null;
      }
      
    youngestChildMapping(d, data) {
        try {
          console.log("Input Date:", d);
          console.log("Input Gender:", data);
      
          let pAge = 0;
          let yid = 0;
      
          if (d === '' || data === '') {
            console.log("Empty input detected, returning 0");
            return "0"; // return early if either input is empty
          }
      
          let set_date = this.parseSafeDate(d);
          if (!set_date || isNaN(set_date)) {
            console.log("Invalid date detected, returning 0");
            return "0";
          }          
          console.log("Parsed Date:", set_date);
      
          let set_diff = new Date(Date.now() - set_date.getTime());
          console.log("Age Difference Date Object:", set_diff);
      
          let age = Number(set_diff.toISOString().slice(0, 4)) - 1970;
          console.log("Calculated Age:", age);
      
          // Determine pAge category
          if (set_diff.getMonth() < 6 && age === 0) {
            pAge = 0;
          } else if ((set_diff.getMonth() > 5 && age === 0) || age === 1) {
            pAge = 1;
          } else if (age === 2 || age === 3) {
            pAge = 2;
          } else if (age === 4 || age === 5) {
            pAge = 3;
          } else if (age >= 6) {
            pAge = 4;
          }
          console.log("pAge Group:", pAge);
      
          // Map pAge to yid based on gender
          switch (data.toLowerCase()) {
            case "girl":
              switch (pAge) {
                case 0: yid = 1; break;
                case 1: yid = 2; break;
                case 2: yid = 3; break;
                case 3: yid = 4; break;
                case 4: yid = 14; break;
                default: yid = 0; break;
              }
              break;
            case "boy":
              switch (pAge) {
                case 0: yid = 1; break;
                case 1: yid = 6; break;
                case 2: yid = 7; break;
                case 3: yid = 8; break;
                case 4: yid = 13; break;
                default: yid = 0; break;
              }
              break;
            default:
              yid = 0;
          }
      
          console.log("Final yid:", yid);
          return yid.toString();
        } catch (error) {
          console.error("Error in youngestChildMapping:", error);
          return "0";
        }
      }
      
      
    getStatsData(){
        var sublistul = [22,33,44];
        var clr = ["#ee534f","#27a63f","#f5b819"];

        if (this.calendarRangeLoaded) {
            actions.calendarRange(sublistul, "", clr);
        } else {
            service.calendarRangeFiles(this);
        }
    }
    childBirthdate() {
        document.getElementById("lmp").checked = true;
        document.getElementById("child_date").disabled = false;
    }
    childDueDate() {
        document.getElementById("lmp").checked = true;
        document.getElementById("child_date").disabled = false;
    }

    onKeyPressDate = (event) => {
        event.returnValue = false;
        if (event.preventDefault) event.preventDefault();
    }
    onFocusDate = (event) => {
        // //console.log("onFocusDate================>", event);
        if (document.getElementById("lmp").checked) {
            document.querySelector(".tap_here").style.display = "none";
        } else {
            document.querySelector(".tap_here2").style.display = "none";
        }
        var val;
        if (event.target.value && event.target.value != '') {
            val = new Date(event.target.value);
            var y = val.getFullYear();
            var m = val.getMonth() + 1;
            var d = val.getDate();
            m = m > 9 ? m : "0" + m;
            d = d > 9 ? d : "0" + d;
            var finalVal = y + '-' + m + '-' + d;
            event.target.value = finalVal;
        }
        event.target.type = "date";
        event.target.readOnly = false;
        if (event.preventDefault) event.preventDefault();
        event.target.focus();
    }

    setConsumeData(LoadedFeedDataArr){ 
         var arr_all_ids_data = [];
            LoadedFeedDataArr.forEach((feed) => {
            var arr_all_ids = {};
            if(feed.type == "articles"){ 
               arr_all_ids.articleId = [];
               feed.data.forEach((article) => {
                  arr_all_ids.articleId.push(  article.articleId);
               });
            } else if(feed.type == "QNA" || feed.type == "qna"){
                arr_all_ids.questionId = [];
                feed.data.forEach((question) => {
                arr_all_ids.questionId.push(  question.question_id);
                });
            } else if(feed.type == "video"){ 
                arr_all_ids.videoIds = [];
                feed.data.forEach((video) => {
                  arr_all_ids.videoIds.push(  video.id);
                });
            } else if(feed.type == "memoriesview"){
                arr_all_ids.memoriesId = [];
                feed.data.forEach((memory) => {
                  arr_all_ids.memoriesId.push(  memory.memoryId);
                });
               
            } 
            else if(feed.type == "Discussion" || feed.type == "discussion") { 
                arr_all_ids.discussionId = [];
               feed.data.forEach((discussion) => {
                  arr_all_ids.discussionId.push(  discussion.discussion_id);
                });
             } else if(feed.type == "dietplanmom") {
               //  arr_all_ids['discussionId'] = [];
               // foreach (feed.data as dietplanmom) {
               //  arr_all_ids['discussionId'].push(  dietplanmom.discussion_id);
               // });
             } else if(feed.type == "mybumpie"){
               arr_all_ids.mybumpie = [];
               feed.data.forEach((mybumpie) => {
                  arr_all_ids.mybumpie.push(  mybumpie.frameId);
                });
             } else if(feed.type == "Groups"){
                arr_all_ids.Groups = [];
              
               feed.data.forEach((groups) => {
                  arr_all_ids.Groups.push(  groups.group_id);
                });

               
             } else if(feed.type == "fataldevelopementvide"){
                arr_all_ids.fataldevelopementvide = [];
               feed.data.forEach((fataldevelopementvide) => {
                  arr_all_ids.fataldevelopementvide.push(  fataldevelopementvide.videoUrl);
                });

             } else if(feed.type == "vaccinationandgrowthtracker" || feed.type == "vaccinationtracker"){
               //  arr_all_ids['vaccinationandgrowthtracker'] = [];
               // foreach (feed.data as vaccinationandgrowthtracker) {
               //  arr_all_ids['vaccinationandgrowthtracker'].push(  vaccinationandgrowthtracker.videoUrl);
               // });
             } else if(feed.type == "babykickcounter"){
               // arr_all_ids['babykickcounter'] = [];
               // foreach (feed.data as babykickcounter) {
               //  arr_all_ids['babykickcounter'].push(  babykickcounter.videoUrl);
               // });
             } else if(feed.type == "duedatecalculator"){
                   
             } else if(feed.type == "periodovulationcalculator" || feed.type == "periodovlutioncycleupdate" ){
                  
             } else if(feed.type == "babynames"){
                 arr_all_ids.babynames= [];

                  feed.data.forEach((babynames) => {
                    arr_all_ids.babynames.push(  babynames.babyname);
                  });
             } else if(feed.type == "breastfeeding"){
                
             }
             // var arr_all = (arr_all_ids);
             arr_all_ids_data.push(arr_all_ids);
            //  //console.log("arr_all_ids:: ",arr_all_ids);
            
        });
        //   //console.log("consume data:: ",arr_all_ids_data);
            // return arr_all_ids_data;
            this.setState({
                consumeIds: arr_all_ids_data
            })
            // //console.log("consumeID state",this.state.consumeIds)
    }

     
      FCCornerSlider = () => {
        const { fashionTopData } = this.state;
    
        return (
          <div className="p-3 bg-white shadow rounded-md">
            <h2 className="text-base font-semibold text-gray-800 mb-2">
              Checkout The Bestseller Categories
            </h2>

            <Slider page={"dr-carousel-unit1"} data={this.state.fashionTopData  ? this.state.fashionTopData:[]} />

          </div>
        );
      };
   

    handleKeyDown = (e) => {
        const popupOverlay = document.querySelector(
        ".addAns-overlay-feed.addAns-overlay.feed"
        );
        if (!popupOverlay) return;

        const isVisible = window.getComputedStyle(popupOverlay).display !== "none";
        if (!isVisible) return;

        const popup = this.popupRef.current;
        if (!popup) return;

        // === ESC CLOSE POPUP ===
        if (e.key === "Escape" || e.key === "Esc") {
        e.preventDefault();
        console.log("Escape pressed in Feed popup");
        this.closePopupcommon();

        // Move focus back to the element that opened it
        const prevFocusable = document.querySelector(
            '[data-popup="add-answer' + this.state.question_id + '"]'
        );
        if (prevFocusable) prevFocusable.focus();
        return;
        }

        // === TAB: keep focus inside popup ===
        if (e.key === "Tab") {
        const focusableSelectors = `
            a[href], area[href], input:not([disabled]),
            select:not([disabled]), textarea:not([disabled]),
            button:not([disabled]), [tabindex]:not([tabindex="-1"])
        `;

        const focusableElements = Array.from(
            popup.querySelectorAll(focusableSelectors)
        ).filter((el) => el.offsetParent !== null);

        if (focusableElements.length === 0) return;

        const firstEl = focusableElements[0];
        const lastEl = focusableElements[focusableElements.length - 1];
        const activeEl = document.activeElement;

        // Shift+Tab (reverse)
        if (e.shiftKey) {
            if (activeEl === firstEl || !popup.contains(activeEl)) {
            e.preventDefault();
            lastEl.focus();
            }
        } else {
            // Tab (forward)
            if (activeEl === lastEl || !popup.contains(activeEl)) {
            e.preventDefault();
            firstEl.focus();
            }
        }
        }
    };

    render() {
        let { randomValue } = this.state;
        console.log("loggedin:", this.state.loggedin);
        console.log("childProfileData exists:", this.state.childProfileData);
        console.log(
          "childProfileData has keys:",
          this.state.childProfileData &&
            Object.keys(this.state.childProfileData).length > 0
        );
        console.log("topBannerImg =",this.state.dfpBannerData)  

        return (
            <main className="qa-container personalization_feed_main main-container">
                {/* <Helmet
                    title={this.state.metaTitle}
                    meta={this.state.metaDescription}
                    keywords={this.state.metaKeywords}
                /> */}
                <Helmet>
                    <title>FirstCry Parenting - Planning, Pregnancy & Parenting Advice and Tips</title>
                    <meta name="description" content="FirstCry Parenting - India's largest community to help you through your journey of Getting Pregnant, Pregnancy & Parenting with Articles, Q&A's, Vaccine & Growth Trackers, Baby Names and more." />
                    <meta name="keywords" content="parenting community, parenting tips, pregnancy advice" />
                </Helmet>
                
                <div className="questionLeft fl sub-container">
                    <h1
                        className=""
                        id="skipToH1"
                        tabIndex={0}
                        style={{ fontSize: "0px", opacity: 0 }}
                        >
                        FirstCry Parenting
                    </h1>
                    {/* <span id="skipToH1" tabIndex={-1}>{this.state.loggedin ? "Hi , You are Login" : "Oops !! You are logged Out"}</span> */}
                    <div className="personalization_feed fl">

                        <ChildListOverlay eleRef={this} />
                        <ChooseWhetherYouAre eleRef={this} />
                        <AddChildDetails eleRef={this} />

                        <section className="slideTemp personalization_tools_bar_slide">
                            <SlideItem page={"dr-carousel-unit"} data={this.state.arrtoolslider} />
                        </section> 
                       
                        <section className="slideTemp slider_desktop_rdius_view_ps">
                            <Slider page={"dr-carousel-unit"} data={this.state.dfpBannerData && this.state.dfpBannerData[0] ? this.state.dfpBannerData[0].webUrl:[]} />
                        </section>

                        {this.state.isMobile && this.state.loggedin && this.state.childProfileData  && Object.keys(this.state.childProfileData).length > 0 &&
                        <section className="slideTemp baby-slide-third-section">
                        
                            <SlideBaby page={"dr-carousel-unit"} data={this.state.childProfileData} eleRef={this}/>
                        
                        </section>
                        }

                        {this.state.isMobile && this.state.loggedin && 
                        <MLoggedInRSB sideBarData={this} eleRef={this} />
                        }
                        <MTryingToConcieveRSB sideBarData={this} eleRef={this} />
                        {this.state.isMobile && !this.state.loggedin && 
                        <MNonLoggedinRsp sideBarData={this} eleRef={this} />
                        }

                        {/* {this.FCCornerSlider()} */}
                        
                        { this.state.loggedin && this.state.babyThisWeek && Object.keys(this.state.babyThisWeek).length>0 &&
                        <Babythisweek  babyThisWeek={(this.state.babyThisWeek)?this.state.babyThisWeek:[]}/>
                        }

                        {this.state.highlightsfeed && this.state.highlightsfeed.length > 0 &&  
                            <section className="highlight_the_week_main_div">
                                <div className="highlited_heading_text" role="heading" tabIndex={0} aria-label="Highlights of the Week"> Highlights of the Week</div>
                                <HowFeed highlightsfeed={this.state.highlightsfeed} eleRef={this} />
                            </section>
                        }
                        <div className="main_div_three_and_four_view desktop_checkout_popular_view">
                            <div className="main_div_three_and_four_style">
                            <CommunityFeed highlightsfeed={this.state.communityHome} fashionData={this.state.fashionTopData} nonfashionData={this.state.nonfashionTopData} eleRef={this}  />                                    
                            </div>
                        </div>                       
                  </div>
                </div>
                <div className="registrationRight fl">
                <div className="rightside">
                {this.state.loggedin && this.state.childProfileData  && Object.keys(this.state.childProfileData).length > 0 ?
                <div className="right_side_personalise_view fl">
                    <div className="first_child_personalized_view">
                        <LoggedInRSB sideBarData={(this.state.childProfileData)?this.state.childProfileData.childArr:[]} eleRef={this}/>
                        <TryingToConcieveRSB sideBarData={this} eleRef={this} />
                    </div>
                </div>
                :
                <div className="right_side_personalise_view fl">
                <div className="first_child_personalized_view">
                    <NonLoggedinRsp sideBarData={this} eleRef={this} />
                </div>
            </div>
            } 
                {/* <div className=" fl">
                    <div className="data-container left">
                      <aside className="add_right_registrationRight left">
                        <div className="">
                            {((global.ftk == '' && !this.state.hideLoginCard) || (this.props && this.props.url && this.props.url.includes('/qna') && !this.props.url.includes('/qna/intentmapping'))) &&
                                <div className="askAQues loginwindow">
                                    {this.state.askQueTitle && this.state.askQueTitle != '' &&
                                        <div className="q4 askque-title">{this.state.askQueTitle}</div>
                                    }
                                    {this.state.askQueSubtitle && this.state.askQueSubtitle != '' &&
                                        <div className="q8 askque-text">{this.state.askQueSubtitle}</div>
                                    }
                                    {this.props && this.props.url && this.props.url.includes('/qna') ?
                                        <span className="ask-a-que-btn" id="devaskQuestion">
                                            <span className="b_1 ask-a-que-btn">
                                                <span className="ask-a-que-btn">Ask a Question</span>
                                            </span>
                                        </span>
                                        :
                                        <span>
                                            <span className="b_1 mrgright">
                                                <a href={service.getRedirectUrl(global.loginUrl + '?URL=' + global.currentURL)} target="_self">Login</a>
                                            </span>
                                            <span className="b_1">
                                                <a href={service.getRedirectUrl(global.registerUrl + '?URL=' + global.currentURL)} target="_self">Register</a>
                                            </span>
                                        </span>
                                    }
                                </div>
                            }
                            <div className="downloadApp left">
                              <p className="askedanswer r1542 allHave">Join the largest community of parents and see parenting in a new way</p>
                              <p className="bPink18">Download our App</p>
                              <div className="regParent left">
                                  <div className="login" style={{ display: 'inline-block', overflow: 'hidden' }}>
                                      <div className="form left" style={this.formStyle}>
                                          <input readOnly id="txtMobileNoPrefix" className="txtmobileprefix plus_sign" type="text"  placeholder="+91" data-role="none" value="+91" maxLength="3" />
                                          <input id="txtRMbl" data-role="none" maxLength="15" placeholder="Enter phone number" className="Mobile" type="text" />
                                          <span id="MblErrMsg" className="spanErrorMsg R11red left"></span>
                                          <span className="spanErrorMsg left" id="AriaErrorMsg" style={this.arialErrorStyle}></span>
                                      </div>
                                  </div>                            
                                  <div className="iosAndroid" style={{ display: 'inline-block', overflow: 'hidden' }}>
                                      <div data-id="ios" className="getIos left askB_1 button-lft" id="rdoiphone" >
                                          <div title="FirstCry iOS App Download">
                                              <span className="parentSprite iosTag "></span>
                                              <span className="getAppText">Get for iOS</span>
                                          </div>
                                      </div>
                                      <div data-id="android" className="getAndroid left askB_1 button-lft-mrg" id="rdoandroid" >
                                          <p title="FirstCry Android App Download">
                                              <span className="parentSprite androidTag"></span>
                                              <span className="getAppText">Get for Android</span>
                                          </p>
                                      </div>
                                  </div>
                                  <div className="parentSprite parentingImg"></div>
                              </div>
                    </div>
                          </div>
                      </aside>
                    </div>
                </div> */}
                </div>

                </div>
                {/* Feeds Loader start here */}
                <div className="scroll-loader" style={{ display: "none", position: "fixed" }}> 
              <div className="s-loader-img">
                <img src="//parenting.firstcry.com/personalized-feed/images/loader.gif" alt="loading" title='loading...'/>
              </div> 
              <div className="s-loader-text">Please Wait Updating Your Feed</div>
              </div>
              {/* Feeds Loader end here */}

             {/* Like popup start here */}
                <div className="likes-overlay feeds" style={{ display: "none" }}>
                    <div className="likes-popup">
                <div className="popup-header">
                <span className="icon likesClose fl-lft" data-icon-font="s" onClick={this.closePopupcommon} />
                <span className="M14_white">Likes</span>
                </div>
                <input type="hidden" id="lastevent1" defaultValue={2} />
                <input
                type="hidden"
                id="like_page_no"
                name="like_page_no"
                defaultValue={2}
                />
                <input type="hidden" id="totallikes" name="totallikes" defaultValue={1} />
                <input
                type="hidden"
                id="like_memoryId"
                name="like_memoryId"
                defaultValue=""
                />
                <div className="likes-wrap">
                <div className="like-row clearfix">
                    <a
                    href="https://parenting.firstcry.com/user-profile/undefined"
                    target="_blank"
                    >
                    <div className="like-user-dp left">
                        <img src="https://cdn.fcglcdn.com/brainbees/parenting/img/m/mother_profile.png" alt="Profile image of Mother" title='Mother Profile'/>
                    </div>
                    <div className="like-user-desc left">
                        <span className="M14_42 uname left">Manpreet Kaur chouhan</span>
                        <span className="R13_9e udesc left">
                        Mom of a 1 yr 4 m old girl
                        </span>
                    </div>
                    </a>
                    <span
                    className="like-follow isfollow_undefined"
                    style={{ color: "#9e9e9e" }}
                    >
                    Follow
                    </span>
                </div>
                </div>
                <input id="memoryIdval" name="memoryIdval" type="hidden" defaultValue="" />
                <input id="pageNO" name="pageNO" type="hidden" defaultValue="" />
                    </div>
                </div>
            {/* Like popup end here */}

             <UserListOverlay eleRef={this} />
            
            {/* Answer Popup start here */} 
            
           
            <div className="addAns-overlay-feed addAns-overlay feed"  style={{ display: "none" }}>
                <div className="addAns-popup addAns-popup-new" ref={this.popupRef}>
                    <div className="addAns-header"> 
                    <span className="" role="heading" tabIndex={0} aria-label="Add An Answer">Add An Answer</span>
                    <div className="closeButton" onClick={this.closePopupcommon} onKeyDown={this.closePopupcommon}>
                        <span
                        className="close-container close-icon icon"
                        data-icon-font="C"
                        ></span>
                    </div>
                    </div>
                    <div className="write-comment-container">
                    <textarea
                        rows={4}
                        cols={50}
                        className="comment-box L14_74"
                        placeholder="Write your Answer here"
                        defaultValue={""}
                        id="postAnscomment" tabIndex={0} aria-label="Write your Answer here"
                    />
                    <label htmlFor="fileupload">
                        <div className="participate-attachment">
                        <span data-icon-font="o" className="icon R16_9E" />
                        <span className="R14_61">Attachments</span>
                        </div>
                    </label>
                    <span className="postansErrormsg" style={{ visibility: "hidden" }}>
                        Please write answer 
                    </span>
                    <p className="b_1 right postcomment" onClick={() => actions.postParentingAnswer(this.state.question_id,this.state.userPhoto,this.state.username,this.state.childInfoReq,this.state.docUrl,this.state.answer_type,this.state.question_type,this.state.que_type,this.state.question_creater_id,this.state.answer_details,this.state.expectedDob,this.state.user_type,this.state.qnaUserType,this)} role="button" tabIndex={0} aria-label="Post your Answer" onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault(); // prevent scrolling when pressing Space
                            actions.postParentingAnswer(this.state.question_id,this.state.userPhoto,this.state.username,this.state.childInfoReq,this.state.docUrl,this.state.answer_type,this.state.question_type,this.state.que_type,this.state.question_creater_id,this.state.answer_details,this.state.expectedDob,this.state.user_type,this.state.qnaUserType,this);
                        }
                    }}>Post Answer</p>
                    <div className="file_upload_err" style={{ visibility: "hidden" }}>
                        Only JPEG, JPG, PNG and PDF files allowed of less than 2 MB
                    </div>
                    <div className="uploaded-files-list">
                        <ul>
                            <li className="cmt-image">
                                <span data-icon-font="`" className="icon left"></span>
                                <span className="added-file-name left"></span>
                                <span data-icon-font="&#xe013;" className="icon right" onClick={ (e) =>  actions.cmtFileDelete('image', "ans",this)}></span>
                            </li>
                            <li className="cmt-pdf">
                                <span data-icon-font="&#xe039;" className="icon left"></span>
                                <span className="added-file-name left"></span>
                                <span data-icon-font="&#xe013;" className="icon right" onClick={actions.cmtFileDelete.bind(this, 'pdf', "ans")}></span>
                            </li>
                        </ul>
                    </div>



                    <input
                        type="hidden"
                        id="addAnsquestId"
                        defaultValue="10questionidbb370d38110b3f2"
                    />
                    <input type="hidden" id="feedType" defaultValue="jarvisfeed" />
                    <input type="hidden" id="anscnt" defaultValue={2} />
                    <input type="file" id="fileupload"  onChange={(e) => actions.cmtFileUpload(this)} style={{ display: 'none' }} />
                    </div>
                </div>
             </div>
      
             {/* Answer Popup end here */}

             {/* Comment popup start here */}
             <MemoryComment feedItem={this} eleRef={this} />

             {/* Comment popup end here */}
            
             {/* <script type="text/javascript" src="?"></script> */}
             <script type="text/javascript" src={`https://cdn.fcglcdn.com/brainbees/community/jarvissdk/jssdk-jarviscoreindia.js?v${randomValue}`}></script>

            </main>
        ) 
    }
}

export default withLocation(Feed);
